import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {BaseGeneralComponent} from '../../BaseGeneralComponent';
import {ProviderModel} from "../../../models/ProviderModel";

@Component({
  selector: 'app-dialog-submit',
  templateUrl: './dialog-submit.component.html',
  styleUrls: ['./dialog-submit.component.scss']
})
export class DialogSubmitComponent extends BaseGeneralComponent implements OnInit {

  dataValues: any;
  displayedColumns: string[];
  providerSelect: ProviderModel;

  constructor(public dialogData: MatDialogRef<DialogSubmitComponent>, @Inject(MAT_DIALOG_DATA) data) {
    super();

    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    if (this.providerSelect.description === this.PROVIDER_DXC) {
      this.displayedColumns = ['confirmed', 'provider', 'numAnnoMese', 'region', 'localCustomer', 'contractType',
        'resourceUnit', 'designServices', 'currency', 'bmc', 'bmv', 'arc', 'arc2', 'rrc', 'rrc2',
        'size', 'site', 'bandwidth1', 'bandwidth2', 'compensationPayment', 'terminationFee', 'pxq'];
    } else {
      this.displayedColumns = ['confirmed', 'provider', 'numAnnoMese', 'region', 'localCustomer', 'contractType',
        'resourceUnit', 'designServices', 'currency', 'bmc', 'bmv', 'arc', 'rrc', 'pxq'];
    }
    this.dataValues = data.result;
  }

  ngOnInit() {
  }

  save() {
    this.dialogData.close();
  }

  close() {
    this.dialogData.close();
  }

}
